module.exports = __webpack_public_path__ + "img/therighteousmind.db61ea55.png";